import React from 'react';
import {graphql, useLazyLoadQuery} from 'react-relay/hooks';
import useQuery from '../../../useQuery';
import useMountedState from '../../../useMountedState';
import {isSet} from '../../../utility';
import getPicksByState from './get-picks-by-state';

export const landImpulseQuery = graphql`
    query useLandImpulseCheckoutPagesLandImpulseQuery($request: LandRequestInput) {
        landImpulse(request: $request) {
            lands {
                service
                pickExs {
                    index
                }
            }
            solves {
                amount
                amountAmount
                feeAmount
                serviceFeeAmount
                basis
                discountAmount
                coupon {
                    code
                    discount
                }
            }
        }
    }
`;

const useLand = ({state}) => {
    const {landId = 0} = useQuery();
    const [isRefreshing, setIsRefreshing] = useMountedState();
    const [request, setRequest] = React.useState({picks: getPicksByState(state)});
    const requestDeferred = React.useDeferredValue(request);
    const requestData = useLazyLoadQuery(
        landImpulseQuery,
        {request: requestDeferred}
    );
   
    const land = requestData.landImpulse.lands[landId];
    const currentLandPicks = React.useMemo(
        () =>  land ? land.pickExs.map(e => state[e.index]) : [],
        [state, land]
    );
    const serviceId = land && land.service;
    const coupon = land && requestData.landImpulse.solves[landId].coupon;
    const orderData = {
        total: land && requestData.landImpulse.solves[landId].amount,
        amount: land && requestData.landImpulse.solves[landId].amountAmount,
        serviceFee: land && requestData.landImpulse.solves[landId].serviceFeeAmount,
        basis: land && requestData.landImpulse.solves[landId].basis,
        discountAmount: land && requestData.landImpulse.solves[landId].discountAmount
    };

    const setLandMetas = React.useCallback((metas) => {
        if (isSet(metas)) {
            setRequest({picks: getPicksByState(state), landMetas: metas})
        } else {
            setRequest({picks: getPicksByState(state)});
        }
    });

    const setIsRefreshingCallback = React.useCallback((val) => {
        setIsRefreshing(val);
    }, [setIsRefreshing]);

    React.useEffect(() => {
        if (request !== requestDeferred) {
            setIsRefreshing(true);
        } else {
            setIsRefreshing(false);
        }
    }, [request, requestDeferred, setIsRefreshing]);

    return {
        isRefreshing,
        setIsRefreshing: setIsRefreshingCallback,
        requestPicks: request.picks,
        currentLandPicks,
        serviceId,
        coupon,
        orderData,
        setLandMetas,
        landExists: isSet(land)
    }

};

export default useLand;
